<template>
  <div>
    <el-dialog class="text-16-24" :visible.sync="visible" width="75%">
      <div class="table_wrapper">
        <el-row :gutter="20">
          <el-col :span="24" class="table_welcome">
            <div class="mb-3">
              <el-table :data="displayData" class="reward_logs_main">
                <el-table-column prop="order" :label="$t('promotion.tradingRewards.order')">
                  <template slot-scope="scope">{{ scope.row.ticket }}</template>
                </el-table-column>
                <el-table-column prop="profit" :label="$t('promotion.tradingRewards.profit')">
                  <template slot-scope="scope">
                    {{ scope.row.profit }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('promotion.tradingRewards.rebate')">
                  <template slot-scope="scope"> {{ scope.row.profitRebate }} </template>
                </el-table-column>

                <template slot="empty">{{ $t('promotion.tradingRewards.noRewardHistory') }}</template>
              </el-table>
            </div>
            <Pagination
              :table-data="tableData"
              :display-data.sync="displayData"
              :customizedPageSize="pageSize"
            ></Pagination>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ 'Close' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import Pagination from '@/components/Pagination';

export default {
  name: 'RewardLogsDialog',
  components: { Pagination },

  props: {
    dialogVisible: Boolean,
    logDetails: Object
  },
  data() {
    return {
      displayData: [],
      pageSize: 10,
      visible: false
    };
  },
  computed: {
    tableData() {
      return (this.logDetails && this.logDetails.trades) || [];
    }
  },
  watch: {
    dialogVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:dialogVisible', bool);
    }
  },
  methods: {
    closeDialog() {
      this.pageSize = 10;
      this.$emit('closeDialog');
    },
    formatDate(dateTime) {
      return dateTime ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss') : '-';
    }
  }
};
</script>

<style lang="scss" scoped>
.table_wrapper {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 2px;
}

.reward_logs_main {
  max-height: 400px;
  overflow-y: auto;
}
</style>
